<template>
  <div class="file-item-content file-email">
        <div class="file-name">{{title}}</div>
        <div class="file-bg" @click="viewFile">
            <div class="file-content">
                <a class="file-name-link" :href="'mailto:'+`${content}`">{{content}}</a>
            </div>
        </div>
  </div>
</template>

<script>

export default {
  uuid: '00000000-0000-0000-0000-000000100017',
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    title() {
      return this.datamodel.value.emailname
    },
    content() {
        return this.datamodel.value.emailaddress
    }
  },
  methods: {
    viewFile() {

    }
  },
  created() {},
  mounted() {

  }
}
</script>
<style lang="scss">
.file-item-content {
    // height: 100px;
    margin: 16px 0;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.04em;
    text-align: left;
    flex: 1;
    .file-name {
        color: #000
    }
    .file-bg {
        margin: 8px 31px;
        background-color: #F1F3F4;
        display: flex;
        height: 36px;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        .file-content {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .file-icon {
                display: flex;
                align-items: center;
            }
        }
        .file-name-link {
            // margin-left: 16px;
            flex: 1;
            overflow: hidden;
            color: #999;
        }
    }

}

.file-email {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // padding: 0 31px;
    .file-name {
        margin-right: 8px;
        max-width: 120px;
    }
    .file-bg {
        flex: 1;
        margin: 0;
        overflow: hidden;
    }
}


</style>
